import styled from 'styled-components'
import { Spacing, Colors, Shadows } from 'cio-design-library/design-tokens'

type Props = {
  $isFooterShadowVisible?: boolean
}

export const FooterContainer = styled.div<Props>`
  box-shadow: ${({ $isFooterShadowVisible }) =>
    $isFooterShadowVisible ? Shadows.lightWithBorderShadowMid : 'none'};
  transition: box-shadow 0.2s ease-out;
  padding: ${Spacing.XS};
  display: flex;
  gap: ${Spacing['2XS']};
  flex-wrap: wrap;
  background-color: ${Colors.White};
  border-radius: ${Spacing.XS} ${Spacing.XS} 0 0;
  position: sticky;
  bottom: 0;
  width: 100%;
  z-index: 1;

  & > * {
    flex: 1 1 calc(50% - ${Spacing['2XS']});
  }
`
